import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import axios from "axios";
import './PageFAbody.css'; // Import the CSS file

export default function UserPageBody() {
    const location = useLocation();
    const { phone } = location.state; 
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [customerData, setCustomerData] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const ordersPerPage = 25;

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/userOrder/${phone}`)
            .then(response => {
                const ordersData = response.data;
                if (ordersData.length > 0) {
                    const { CustomerName, CustomerPhone, CustomerAddress, CustomerPin } = ordersData[0];
                    setCustomerData({ CustomerName, CustomerPhone, CustomerAddress, CustomerPin });
                }
                setOrders(ordersData);
                setFilteredOrders(ordersData);
            })
            .catch(error => {
                console.error('Error fetching orders:', error);
            });
    }, [phone]);

    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);
    const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleSearch = () => {
        const filtered = orders.filter(order => {
            const orderDate = new Date(order.OrderDate).toLocaleDateString();
            return orderDate.includes(searchTerm);
        });
        setFilteredOrders(filtered);
        setCurrentPage(1); // Reset to first page after search
    };

    const handleRefresh = () => {
        setFilteredOrders(orders);
        setSearchTerm('');
        setCurrentPage(1); // Reset to first page after refresh
    };

    return (
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
            {customerData.CustomerName && (
                <div style={{ marginBottom: "20px", padding: "20px", backgroundColor: "rgba(255, 255, 255, 0.1)", borderRadius: "10px" }}>
                    <h2 className="text-center">Customer Information</h2>
                    <p><strong>Name:</strong> {customerData.CustomerName}</p>
                    <p><strong>Phone:</strong> {customerData.CustomerPhone}</p>
                    <p><strong>Address:</strong> {customerData.CustomerAddress}</p>
                    <p><strong>Pin:</strong> {customerData.CustomerPin}</p>
                </div>
            )}

            {/* Search and Refresh Section */}
            <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
                <input 
                    type="text" 
                    placeholder="Search by date " 
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ padding: "10px", flex: "1", marginRight: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                />
                <button 
                    onClick={handleSearch} 
                    style={{ padding: "10px 20px", marginRight: "10px", borderRadius: "5px", backgroundColor: "#009879", color: "white", border: "none", cursor: "pointer" }}
                >
                    Search
                </button>
                <button 
                    onClick={handleRefresh} 
                    style={{ padding: "10px 20px", borderRadius: "5px", backgroundColor: "#ccc", color: "black", border: "none", cursor: "pointer" }}
                >
                    Refresh
                </button>
            </div>

            {currentOrders.length === 0 ? (
                <p className="display-6">No Data Available, cause this user has not placed any order yet.</p>
            ) : (
                <>
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>Order Date</th>
                                <th>Product Name</th>
                                <th>Product Weight</th>
                                <th>Product Quantity</th>
                                <th>Product Price</th>
                                <th>Status</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentOrders.map(order => (
                                <tr key={order.OrderId}>
                                    <td>{order.OrderId}</td>
                                    <td>{new Date(order.OrderDate).toLocaleDateString()}</td>
                                    <td>{order.ProductName}</td>
                                    <td>{order.ProductWeight}</td>
                                    <td>{order.ProductQuantity}</td>
                                    <td>{order.ProductPrice}</td>
                                    <td>{order.Status}</td>
                                    <td>{order.Amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="pagination">
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            &laquo;
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i + 1}
                                onClick={() => paginate(i + 1)}
                                className={i + 1 === currentPage ? 'active' : ''}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            &raquo;
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}
